import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export function useInfiniteScroll (props) {
  const { getAllDocuments } = props;
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [noMoreData, setNoMoreData] = useState(false);

  useEffect(() => {
    async function getListDocuments () {
      try {
        setLoading(true);
        const result = await getAllDocuments(location);
        if (result && !result.data.listDocuments.nextToken) {
          setNoMoreData(true);
        }
      } catch (error) {
        console.error('Error occurred while fetching document····', error);
      } finally {
        setLoading(false);
      }
    }

    setNoMoreData(false);
    getListDocuments();
  }, [location]);
  return [loading, noMoreData];
}
